import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { motion } from "framer-motion";

const Stats = () => {
  const stats = [
    { number: 48, label: "Hours" },
    { number: 14, label: "Speakers" },
    { number: 240, label: "Seats" },
    { number: 38, label: "Workshop" },
    { number: 16, label: "Sponsors" },
  ];

  return (
    <div className="stats">
      {stats.map((stat, index) => (
        <StatItem key={index} number={stat.number} label={stat.label} />
      ))}
    </div>
  );
};

// variants for the stat items
const numberVariants = {
  hidden: { opacity: 0, y: -50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const labelVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1 } },
};

const StatItem = ({ number, label }) => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    // Run animation only once when it comes into view for the first time
    if (isInView && !hasAnimated) {
      setHasAnimated(true); // Set flag to true to prevent re-animation

      animate(0, number, {
        duration: 2,
        onUpdate(value) {
          if (ref.current) {
            ref.current.textContent = Math.ceil(value);
          }
        },
      });
    }
  }, [number, isInView, hasAnimated]);

  return (
    <div className="stats-content">
      <motion.h2
        variants={numberVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        ref={ref}
      >
        0
      </motion.h2>
      <motion.p
        variants={labelVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {label}
      </motion.p>
    </div>
  );
};

export default Stats;
